
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('click', '.flits-warranty-popup', function(event){
    event.preventDefault();
    Flits('.flits-order-item-warranty').removeClass('active');
    Flits(this).siblings('.flits-order-item-warranty').addClass('active');
    Flits('html').addClass('flits-warranty-popup-open');
  })
  Flits(document).on('click', '.flits-order-item-warranty-close', function(event){
    event.preventDefault();
    Flits(this).parents('.flits-order-item-warranty').removeClass('active');
    Flits('html').removeClass('flits-warranty-popup-open');
  })
  Flits(document).on('Flits:order:AllLoaded', function(event){
    setTimeout(function(){
      Flits('.flits-view-order-button').trigger('click');
    }, 200);
  });
   Flits(document).on('Flits:order:pageClick', function(event){
    setTimeout(function(){
      Flits('.flits-view-order-button').each(function(index, ele){
        if(Flits(this).hasClass('flits-active')){}
        else{
          Flits(this).trigger('click');
        }
      })
    }, 200);
  });

  Flits(document).on("Flits:AccountPage:Visible", function(){
      Flits(".flits-account-container a[href$='/account/logout']").attr("data-no-instant", "");
    }); 
}(Flits));
